<template>
  <div class="container course-create">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/course/list' }">在线课程</el-breadcrumb-item>
        <el-breadcrumb-item>课程创建</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="left-item">
            <span>新订单通知:</span>
            <el-select v-model="admin_ids"
                       placeholder="请选择"
                       style="width: 300px;margin-left:16px;"
                       multiple
                       filterable>
              <el-option v-for="item in $store.state.adminList||[]"
                         :key="item.id"
                         :label="item.nickname"
                         :value="item.id">
              </el-option>
            </el-select>

          </div>
          <div class="left-item">
            <span style="margin:16px;">产品经理:</span>
            <!-- <el-autocomplete class="inline-input"
                             v-model="manager_admin_id"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入内容"
                             :trigger-on-focus="false"
                             @select="handleSelect"
                             clearable
                             style="width: 300px;margin-left:16px;"></el-autocomplete> -->
            <el-select v-model="manager_admin_ids"
                       placeholder="请选择产品经理"
                       style="width: 300px;margin-left:16px;"
                       multiple
                       filterable>
              <el-option v-for="item in $store.state.adminList||[]"
                         :key="item.id"
                         :label="item.nickname"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="right">
          <el-button plain
                     @click="handleClose">取消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">课程详情设置</h3>
      <div class="content">
        <el-form :model="dataForm"
                 :rules="rules"
                 ref="dataForm"
                 label-width="130px"
                 class="dataForm">
          <div class="form-header">
            <div class="form-header-inner">基础信息</div>
          </div>
          <el-form-item label="上传主图："
                        prop="picture_url">
            <div class="cover-wrap">
              <div class="top">
                <div class="left">
                  <el-image class="cover-selected"
                            :src="dataForm.picture_url"
                            fit="fit" />
                  <p class="label">当前主图</p>
                </div>
                <div class="middle"></div>
              </div>
              <div>
                <el-upload class="avatar-uploader"
                           :action="imgUploadUrl"
                           :headers="uploadHeaders"
                           :show-file-list="false"
                           :on-success="handleUploadSuccess"
                           :before-upload="handleBeforeUpload">
                  <el-button size="small"
                             plain><i class="el-icon-upload2" />自定义主图</el-button>
                  <div slot="tip"
                       class="el-upload__tip">
                    支持扩展名：.jpg .png .jpge ; 建议图片尺寸为750*422; 图片大小不超过1MB;
                  </div>
                </el-upload>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="课程名称："
                        prop="name">
            <el-input v-model="dataForm.name"
                      placeholder="输入课程名称"></el-input>
          </el-form-item>
          <el-form-item label="课程简介："
                        prop="description">
            <el-input v-model="dataForm.description"
                      placeholder="输入课程简介"
                      type="textarea"
                      :rows="2"></el-input>
          </el-form-item>
          <el-form-item label="课程标签："
                        prop="tags">
            <el-input v-model="dataForm.tags"
                      placeholder="输入课程标签，多个用英文逗号隔开"></el-input>
          </el-form-item>
          <!-- <el-form-item label="课程分类"
                        prop="category_id">
            <el-select v-model="dataForm.category_id"
                       placeholder="选择分类"
                       style="width: 300px">
              <el-option v-for="item in categorys"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="课程分类"
                        prop="category_ids">
            <el-select v-model="dataForm.category_ids"
                       placeholder="选择分类（可多选）"
                       style="width: 300px"
                       multiple>
              <el-option v-for="item in categorys"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程类型"
                        prop="course_type">
            <el-select v-model="dataForm.course_type"
                       placeholder="选择类型"
                       style="width: 300px">
              <el-option v-for="item in filter.types"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程年份"
                        prop="year">
            <el-select v-model="dataForm.year"
                       placeholder="选择课程年份"
                       style="width: 300px">
              <el-option v-for="item in years"
                         :key="item"
                         :label="item"
                         :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item label="课时数"
                          prop="hours">
              <el-input v-model="dataForm.hours"
                        placeholder="输入课时数"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="发布人："
                        prop="author_id">
            <el-select v-model="dataForm.author_id"
                       filterable
                       remote
                       reserve-keyword
                       :remote-method="fetchAuthorList"
                       placeholder="搜索作者，选择保存"
                       style="width: 300px">
              <el-option :label="`${item.realname}/${item.mobile}`"
                         :value="item.id"
                         v-for="item in authors"
                         :key="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="适合科目："
                        prop="subjects">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in subjects"
                      closable
                      :disable-transitions="false"
                      @close="handleSubjectRemove(item)">
                {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                }}
              </el-tag>
              <el-button type="text"
                         @click="handleSubjectChoose">选择科目</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合专业："
                        prop="majors">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in majors"
                      closable
                      :disable-transitions="false"
                      @close="handleMajorRemove(item)">
                {{ `${item.name}/${item.code}` }}
              </el-tag>
              <el-button type="text"
                         @click="handleMajorChoose">选择专业</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合院校："
                        prop="colleges">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in colleges"
                      closable
                      :disable-transitions="false"
                      @close="handleCollegeRemove(item)">
                {{ `${item.name}` }}
              </el-tag>
              <el-button type="text"
                         @click="handleCollegeChoose">选择院校</el-button>
            </div>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item class="price"
                          label="售价："
                          prop="price">
              <el-input v-model="dataForm.price"
                        placeholder="输入售价"></el-input>
            </el-form-item>
            <el-form-item label="划线价："
                          prop="market_price">
              <el-input v-model="dataForm.market_price"
                        placeholder="输入划线价"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="花呗分期："
                        prop="year">
            <el-select v-model="dataForm.hb_fq_num_level"
                       placeholder="选择花呗分期"
                       style="width: 300px">
              <el-option label="含手续费"
                         :value="0">
              </el-option>
              <el-option label="三期免息"
                         :value="3">
              </el-option>
              <el-option label="六期免息"
                         :value="6">
              </el-option>
              <el-option label="十二期免息"
                         :value="12">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item label="基础在学数："
                          prop="virtual_count">
              <el-input v-model="dataForm.virtual_count"
                        placeholder="输入在学基础数"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="课程起止日期："
                        prop="datetime">
            <el-date-picker class="datetime"
                            v-model="dataForm.datetime"
                            type="datetimerange"
                            :default-time="['00:00:00', '23:59:59']"
                            format="yyyy-MM-dd HH:mm"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 300px">
            </el-date-picker>
          </el-form-item>
          <!--           <el-form-item label="发布人：" prop="author_id">
            <el-select
              v-model="dataForm.author_id"
              filterable
              remote
              reserve-keyword
              :remote-method="fetchAuthorList"
              placeholder="搜索作者，选择保存"
              style="width: 300px"
            >
              <el-option
                :label="`${item.realname}/${item.mobile}`"
                :value="item.id"
                v-for="item in authors"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="短书标识："
                        prop="link_id">
            <el-input v-model="dataForm.link_id"
                      placeholder="输入短书唯一标识"
                      type="textarea"
                      :rows="2"></el-input>
          </el-form-item>
          <el-form-item label="短书URL："
                        prop="link_url">
            <el-input v-model="dataForm.link_url"
                      placeholder="输入短书课程URL"></el-input>
          </el-form-item>
          <el-form-item label="分享链接"
                        prop="share_url">
            <el-input v-model="dataForm.share_url"
                      placeholder="输入分享链接"></el-input>
          </el-form-item>
          <el-form-item label="关联用户分组："
                        prop="user_category_ids">
            <el-select v-model="dataForm.user_category_ids"
                       placeholder="选择分类"
                       style="width: 800px"
                       multiple>
              <el-option v-for="item in userCategorys"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="协议编码"
                        prop="product_agreement_codes">
            <el-select v-model="dataForm.product_agreement_codes"
                       placeholder="选择协议编码"
                       multiple
                       style="width: 300px">
              <el-option v-for="item in $store.state.agreementList||[]"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="排序值：">
            <el-input v-model="dataForm.sort"
                      placeholder="输入排序值"
                      style="width:300px;"
                      oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item label="配送服务："
                          prop="is_deliver">
              <el-switch v-model="dataForm.is_deliver"></el-switch>
            </el-form-item>
            <el-form-item label="公开课："
                          prop="public_status">
              <el-switch v-model="dataForm.public_status"></el-switch>
            </el-form-item>
            <el-form-item label="发送短信："
                          prop="sms_notify_status">
              <el-switch v-model="dataForm.sms_notify_status"></el-switch>
            </el-form-item>
            <el-form-item label="联系老师："
                          prop="contact_teacher_status">
              <el-switch v-model="dataForm.contact_teacher_status"
                         @change="handleContactSwitchChange"></el-switch>
            </el-form-item>
          </div>
          <el-form-item label="运费模板："
                        v-if="dataForm.is_deliver"
                        prop="template"
                        style="marginLeft:70px">
            <el-tag class="subject-item"
                    size="medium"
                    :disable-transitions="false"
                    v-if="templateName != ''">
              {{ templateName }}
            </el-tag>
            <el-link type="primary"
                     :underline="false"
                     @click="recordDialog = true">选择模板</el-link>
          </el-form-item>
          <div class="form-header">
            <div class="form-header-inner">服务老师</div>
          </div>
          <Teacher :content="{ teachers: teachers, type: 1 }"
                   @save="saveTeacher" />
          <div class="form-header">
            <div class="form-header-inner">规格属性</div>
          </div>
          <Property :productId="dataForm.id"
                    :content="{ skus: skus, properties: properties }"
                    @save="saveSkus" />
          <div class="form-header"
               style="display: flex;justify-content: space-between;align-items: center;">
            <div class="form-header-inner">详情描述</div>
            <el-switch v-model="editTypes"
                       active-text="百度编辑器"
                       inactive-text="默认编辑器"
                       @change="editChange">
            </el-switch>
          </div>
          <el-form-item class="course-detail"
                        label="课程详情描述："
                        prop="detail">

            <VueEditor v-if="!editTypes"
                       :content="dataForm.detail"
                       placeholder="请输入课程描述，可以是图片也可以是文字，排版尽量美化，有助于用户购买"
                       @change="handleDetailChange" />
            <UEeditor :setDataStr="dataForm.detail"
                      @change="initDtaForm"
                      v-else />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"></SubjectChoose>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>
    <Record :isVisible="recordDialog"
            :dataForm="{ templateName: templateName }"
            @choseList="choseList"
            @close="recordDialog = false"></Record>
  </div>
</template>

<script>
import Property from '../product/property'
import Teacher from '../product/teacher'
import VueEditor from '@/components/VueEditor'
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
import TeacherChoose from '@/components/dialog/teacher/TeacherChoose'
import MajorChoose from '@/components/dialog/major/MajorChoose'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import Record from '@/components/dialog/subject/record'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { courseCreate, courseCategoryList } from '@/api/course'
import { seniorList } from '@/api/senior'
import { memberCategoryList } from '@/api/member'
import { expressTemplateDetail } from '@/api/index.js'
import UEeditor from '@/components/UEeditor'
import { getStorage } from '@/utils/helper'

export default {
  components: {
    Property,
    Teacher,
    VueEditor,
    SubjectChoose,
    TeacherChoose,
    MajorChoose,
    CollegeChoose,
    Record,
    UEeditor,
  },
  data() {
    return {
      editTypes: false,
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      recordDialog: false,
      templateId: null,
      templateName: '',
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      dataForm: {
        picture_url: '',
      },

      subjects: [],
      majors: [],
      colleges: [],
      teachers: [],
      authors: [],
      categorys: [],
      userCategorys: [],
      skus: [],
      properties: [],
      filter: {
        types: [
          { label: '录播课', value: 1 },
          { label: '直播课', value: 2 },
          { label: '直播+录播', value: 3 },
        ],
      },
      rules: {
        name: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
          {
            min: 3,
            max: 35,
            message: '长度在 3 到 35 个字符',
            trigger: 'blur',
          },
        ],
        description: [
          { required: true, message: '请输入课程简介', trigger: 'blur' },
        ],
        course_type: [
          { required: true, message: '请选择课程类型', trigger: 'change' },
        ],
        year: [
          { required: true, message: '请选择课程年份', trigger: 'change' },
        ],
        hours: [
          { required: true, message: '请输入课时数', trigger: 'blur' },
          {
            pattern: /^(\d+|\d+\.\d{1,2})$/,
            message: '输入最多两位小数的数字',
          },
        ],
        market_price: [
          { required: true, message: '请输入划线价', trigger: 'blur' },
          {
            pattern: /^(\d+|\d+\.\d{1,2})$/,
            message: '输入最多两位小数的数字',
          },
        ],
        price: [
          { required: true, message: '请输入售价', trigger: 'blur' },
          {
            pattern: /^(\d+|\d+\.\d{1,2})$/,
            message: '输入最多两位小数的数字',
          },
        ],
        vip_discount_rate: [
          { required: true, message: '请选择会员优惠', trigger: 'blur' },
        ],
        picture_url: [
          {
            required: true,
            message: '请上传主图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.dataForm.picture_url) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        // subjects: [
        //   { required: true, message: '请选择适合科目', trigger: 'change', validator: (rule, value, callback) => {
        //     if (!this.subjects.length) {
        //       return callback(new Error(rule.message))
        //     } else {
        //       callback()
        //     }
        //   }}
        // ],
        author_id: [
          { required: false, message: '请选择作者/学长', trigger: 'blur' },
        ],
        datetime: [
          { required: true, message: '请设置课程有效日期', trigger: 'change' },
        ],
        virtual_count: [
          { required: true, message: '请输入基础在学数', trigger: 'blur' },
        ],
        detail: [
          { required: true, message: '请输入课程详情描述', trigger: 'blur' },
        ],
        link_id: [
          { required: false, message: '请输入短书标识', trigger: 'blur' },
        ],
        link_url: [
          { required: false, message: '请输入短书课程URL', trigger: 'blur' },
        ],
        user_category_ids: [
          { required: true, message: '请选择关联用户分类', trigger: 'blur' },
        ],
        category_ids: [
          {
            required: true,
            message: '请选择课程分类',
            trigger: 'change',
            type: 'array',
            min: 1,
          },
        ],
      },
      admin_ids: '',
      manager_admin_ids: [],
      // manager_admin_id: '',
    }
  },
  watch: {
    // 时间数据监听
    'dataForm.datetime': {
      handler(value) {
        if (value) {
          this.dataForm.start_time = this.$moment(value[0]).valueOf()
          this.dataForm.end_time = this.$moment(value[1]).valueOf()
        } else {
          this.dataForm.start_time = null
          this.dataForm.end_time = null
        }
      },
    },
  },
  computed: {
    years() {
      const list = []
      list.push((this.$moment().year() + -1).toString())
      list.push((this.$moment().year() + 0).toString())
      list.push((this.$moment().year() + 1).toString())
      list.push((this.$moment().year() + 2).toString())
      list.push((this.$moment().year() + 3).toString())
      return list
    },
  },
  created() {
    this.$store.dispatch('getAdminList')
    this.$store.dispatch('fetchAgreementList')
  },
  mounted() {
    this.scrollToTop()
    this.fetchCategoryList()
    this.fetchUserCategoryList()
    this.manager_admin_ids = [getStorage('admin_user').id]
    // this.manager_admin_id = getStorage('admin_user').nickname
    // this.dataForm.manager_admin_id = getStorage('admin_user').id
  },
  methods: {
    handleContactSwitchChange(value) {
      // 如果开关要开启，检查是否有售后老师
      if (value) {
        const hasAfterSalesTeacher = this.teachers.some(
          (teacher) => teacher.type === 3
        )

        if (!hasAfterSalesTeacher) {
          this.$message.warning('请先添加售后老师再开启联系老师功能')
          // 恢复开关状态为关闭
          this.$nextTick(() => {
            this.dataForm.contact_teacher_status = false
          })
          return
        }
      }
      // 开关关闭时直接通过，不做限制
    },

    editChange(val) {
      this.editTypes = val
    },
    // 选择运费模板
    choseList(val) {
      if (val && val[0]) {
        this.templateId = val[0].id
        this.templateName = val[0].name
      }
    },
    // 作者列表请求
    fetchAuthorList(name) {
      seniorList({ keyword: name, isPaging: 0 }).then((res) => {
        this.authors = res.list
      })
    },
    // 课程分类列表请求
    fetchCategoryList() {
      courseCategoryList({ status: 1, isPaging: 0 }).then((res) => {
        let list = res.list || []
        list.unshift({ id: null, name: '全部' })
        this.categorys = list
      })
    },
    // 获取用户分类列表
    fetchUserCategoryList() {
      memberCategoryList({ status: 1, isPaging: 0 }).then((res) => {
        this.userCategorys = res.list || []
      })
    },
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    handleDetailChange(editor) {
      this.dataForm.detail = editor.html
      console.log(this.dataForm.detail)
    },
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id)
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
    },
    saveTeacher({ teachers }) {
      console.log('teacher', teachers)
      this.teachers = teachers
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    saveSkus(val) {
      if (val.skus) {
        this.skus = val.skus
      }
      if (val.properties) {
        this.properties = val.properties
      }
      if (!this.properties.length) {
        this.skus = []
      }
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.picture_url = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!')
      }
      return isLt2M
    },
    handleSubmit() {
      if (
        this.skus.findIndex((v) => {
          return v.price == '' || v.stock == ''
        }) >= 0
      ) {
        this.$message.error('请填写所有必填信息')
        return
      }
      if (
        this.skus.findIndex((v) => {
          return (
            !/^(\d+|\d+\.\d{1,2})$/.test(v.price) || !/^(\d+|\d)$/.test(v.stock)
          )
        }) >= 0
      ) {
        this.$message.error('价格或库存输入不正确')
        return
      }
      if (this.dataForm.contact_teacher_status) {
        const hasAfterSalesTeacher = this.teachers.some(
          (teacher) => teacher.type === 3
        )
        if (!hasAfterSalesTeacher) {
          this.$message.error('开启联系老师功能后，必须添加售后老师')
          return
        }
      }
      console.log(this.dataForm, '22222222222')
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm, {
            is_deliver: this.dataForm.is_deliver ? 1 : 0,
            deliver_express_template_id: this.templateId
              ? this.templateId
              : null,
            public_status: this.dataForm.public_status ? 1 : 0,
            sms_notify_status: this.dataForm.sms_notify_status ? 1 : 0,
            contact_teacher_status: this.dataForm.contact_teacher_status
              ? 1
              : 0,
            subjects: this.subjects.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            majors: this.majors.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            colleges: this.colleges.map((item) => ({ code: item.code })),
            teachers: this.teachers.map((item) => ({
              id: item.id,
              type: item.type,
              sort: item.sort,
            })),
            skus: this.skus,
            user_category_ids: this.dataForm.user_category_ids.join(','),
            admin_ids: this.admin_ids.join(','),
            product_agreement_codes:
              this.dataForm.product_agreement_codes.join(','),
            category_ids: this.dataForm.category_ids.join(','),
            manager_admin_ids: this.manager_admin_ids.join(','),
          })
          params.market_price = Number(params.market_price)
          params.price = Number(params.price)
          courseCreate(params)
            .then((res) => {
              this.$message.success(`创建成功`)
              this.$refs['dataForm'].resetFields()

              this.$router.go(-1)
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          this.$message.error('请填写所有必填信息')
          return false
        }
      })
    },
    handleClose() {
      this.$router.go(-1)
    },
    initDtaForm(e) {
      this.dataForm.detail = e
    },
    querySearch(queryString, cb) {
      var restaurants = this.$store.state.adminList.map((v) => {
        return {
          value: v.nickname,
          id: v.id,
        }
      })
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handleSelect(item) {
      console.log(item)
    },
  },
}
</script>

<style scoped lang="less">
.course-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;
    .left {
      display: flex;
      align-items: center;
    }
    .left-item {
    }

    .dataForm {
      min-width: 700px;
      width: 100%;
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
    .cover-wrap {
      .top {
        display: flex;
        margin-bottom: 10px;
      }
      .left,
      .right {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .middle {
        flex: 1;
      }
      .cover-selected {
        height: 105px;
      }
      .el-upload__tip {
        line-height: 20px;
      }
    }
    .form-item-wrap {
      display: flex;

      /deep/ .el-input {
        width: 300px;
      }
    }
    .course-detail {
      /deep/ .el-form-item__content {
        line-height: 1;
      }
    }
    .tag-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .subject-item,
    .teacher-item {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
  .form-header {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    background: #f8f8f8;
    margin-bottom: 20px;

    .form-header-inner {
      padding: 10px;
    }
  }
}
</style>
